import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import {
	ChartTitle,
	ChartWrapper,
	DashBoardDiv,
	GridItem,
	PieWrapper,
	StyledGrid,
	TextGrid,
	TextItem,
	WaterfallWrapper,
} from '../FinanceReport.styles';
import { ApSimpleDropdown, colors } from '@alixpartners/ui-components';
import { displayOrder, savingsType } from 'SpendController/utils';

const xCategories = [
	'Eliminate',
	'Reduce Demand',
	'Consolidate',
	'Continue to Use',
	'Actioned Baseline',
	'Unactioned Baseline',
	// '',
	'Intial Baseline Spend',
];
const DashBoardChart = props => {
	const {
		waterfallData,
		vendorCountData,
		option1,
		setSavingCategory,
		savingsCategory,
	} = props;

	const options = {
		chart: {
			// spacingTop: 20,
			type: 'waterfall',
			backgroundColor: 'rgba(0,0,0,0)',
			style: {
				fontFamily: 'Roboto',
				fontSize: '14px',
			},
			marginTop: 50,
			spacingBottom: 20,
			height: 400,
			spacing: [0, 0, 0, 10],
			events: {
				render() {
					const chart = this;

					const series = chart.series[0];
					const lastThreePoints = series.points.slice(0, 3);
					let xMin = Math.min(
						...lastThreePoints.map(point => point.shapeArgs.x)
					);
					let xMax = Math.max(
						...lastThreePoints.map(
							point => point.shapeArgs.x + point.shapeArgs.width
						)
					);

					let yMin = Math.min(...series.points.map(point => point.shapeArgs.y));

					let yAxisZero = chart.yAxis[0].toPixels(0);

					if (chart.customBox) {
						chart.customBox.destroy();
					}

					chart.customBox = chart.renderer
						.rect(
							xMin - 5, // Start from the leftmost bar
							yMin + 40, // Top of the tallest bar
							xMax - xMin + 28, // Width from the leftmost to rightmost bar
							yAxisZero - yMin - 10 // Height from top of the bars down to the X-axis
						)
						.attr({
							stroke: colors.blue500,
							'stroke-width': 2,
							'stroke-dasharray': '5,5',
							fill: 'none',
							zIndex: 5,
						})
						.add();
				},
			},
		},
		title: {
			text: null,
		},
		xAxis: {
			reversed: true,
			lineColor: '#000000',
			labels: {
				style: {
					fontSize: '13px',
					fontWeight: 'normal',
					lineHeight: '13px',
					letterSpacing: 0,
					color: colors.grey500,
				},
			},
			gridLineWidth: 0,
			categories: xCategories,
		},
		yAxis: {
			visible: false,
		},
		legend: {
			enabled: false,
		},
		credits: {
			enabled: false,
		},
		exporting: {
			enabled: false,
		},
		tooltip: {
			enabled: true,
			shared: true,
			distance: 56,
			useHTML: true,
			backgroundColor: 'rgba(255,255,255, 0.9)',
			borderWidth: 0,
			outside: true,
			borderRadius: 2,
			formatter: function() {
				if (xCategories.slice(0, 3).includes(this.x)) {
					return ['<b>' + this.x + '</b> <br/>'].concat(
						this.points
							? this.points.map(function(point) {
									return point.series.name + ': ' + point.y + '<br/>';
							  })
							: []
					);
				} else {
					const { points } = this;
					const sumSpend = points.reduce((sum, obj) => sum + (obj.y || 0), 0);
					return `<b>  ${this.x}  </b> <br/>   ${sumSpend}`;
				}
			},
		},
		plotOptions: {
			waterfall: {
				stacking: 'normal',
				borderWidth: 0,
				// grouping: false,
			},
			series: {
				animation: true,
				stacking: 'normal',
				grouping: false,
				pointWidth: 50,
				dataLabels: {
					// enabled: true,
					// align: 'center',
					// verticalAlign: 'top',
					// inside: false,
					// y: -20,
					// formatter: function() {
					// 	if (isUndefined(this.y)) {
					// 		return '$0';
					// 	} else {
					// 		return spendFormatter(this.y, true);
					// 	}
					// },
					style: {
						fontSize: '10px',
						color: 'black',
					},
				},
			},
		},
		series: waterfallData,
	};

	return (
		<>
			<DashBoardDiv>
				<ChartWrapper>
					<WaterfallWrapper>
						<ChartTitle>
							Total Spend Controller Baseline Spend By Recommended Action($M)
						</ChartTitle>
						<HighchartsReact highcharts={Highcharts} options={options} />
					</WaterfallWrapper>
					<PieWrapper>
						<ChartTitle>
							{`${savingsCategory.label} Opportunity($M) `}
							<ApSimpleDropdown
								options={savingsType}
								selected={savingsCategory}
								onChange={v => setSavingCategory(v)}
								label="Savings Type"
							/>
						</ChartTitle>
						<HighchartsReact highcharts={Highcharts} options={option1} />
					</PieWrapper>
				</ChartWrapper>
			</DashBoardDiv>
			<div style={{ margin: '15px 20px 15px 20px' }}>
				<div
					style={{ fontSize: '14px', fontFamily: 'Roboto', fontWeight: 'bold' }}
				>
					Number Of Vendor Records
				</div>
				<StyledGrid>
					{displayOrder.map((item, index) => (
						<GridItem key={index}>{vendorCountData[item.key]}</GridItem>
					))}
				</StyledGrid>
				<TextGrid>
					{displayOrder.map((item, index) => (
						<TextItem key={index}>{item.label}</TextItem>
					))}
				</TextGrid>
			</div>
		</>
	);
};

export default DashBoardChart;

// export default DashBoardChart;
